const translation = {
  en: {
    navtours: "Tours",
    navservices:"Services",
    navaboutus: "About us",
    navcontact: "Contact",
    heroh3: "Choose your destination",
    heroh1: `Its Time for new <br /> Adventures, Escapes <br /> thrills &
              <span> experiences</span>`,
    herop: `Let's embark on a global journey, immersing <br /> ourselves in diverse
              cultures and creating <br /> unforgettable memories as we travel the <br />
              world!`,
    companyh2: `
              It's time to start your <br />
              <span>adventure</span>`,
    companyp: `Traveling is a unique opportunity to discover new cultures, taste
              different cuisines and get to know the world better. However,
              choosing the right travel partner can make the experience much
              more comfortable, enjoyable and unforgettable. This is exactly
              where Joyful Travel comes into play! <br /> <br /> Traveling with
              Joyful Travel gives you not just a holiday, but a unique
              experience. So, why should you choose us?`,
    companyhomecard1:
      "Beyond Borders: A Journey Through the Most Breathtaking Destinations on Earth",
    companyhomecard2:
      "Experience More for Less with Unbeatable Deals and Exclusive Discounts",
    companyhomecard3:
      "Countries, Endless Adventures: Explore the World’s Hidden Gems",
    companyhomecard4:
      "Embark on Unforgettable Journeys with Exclusive Deals and Unique Experiences",

    activetourhr:
      "Active tours according to your interest in different countries",
    activetourlisth1: "Active tours",
    activetourlista: "View all destinations",
    blogsectionhr: "Information from different countries",
    bloglisth2: "There is a world of possibilities out there",
    experienceh1: "Experience",
    homeaboutushr: "Information",
    homeaboutush1: "About us",
    homeaboutush2: "Why us ?",
    homeaboutusheadertext: `What exactly is <span>Joyful <br />Travel</span> ?`,
    homeaboutusheaderparagraph: `Joyful Travel is a travel company founded in 2010 and offers pleasant and comfortable trips all over the world. Aiming to provide its customers with the best holiday experience, Joyful Travel offers comprehensive services from visa procedures to accommodation, from flight tickets to private tours. Explore with us for unforgettable journeys around the world!`,
    homeaboutuslist1h1: "Diversity",
    homeaboutuslist1p:
      "We will inform you about all the options for your trip, about special campaigns and about the quality of a product, and you can choose a travel package that suits your needs.",
    homeaboutuslist2h1: "A convenient universal sale",
    homeaboutuslist2p:
      "We'll save you time and money by planning every aspect of your trip, from airlines to car rentals and accommodations to business meetings.",
    homeaboutuslist3h1: "Confidence",
    homeaboutuslist3p:
      "Since 2015, we have earned the trust of our customers with our transparent and quality service. We are with you every step of the way to provide superior service to our customers unlike any other company.",

    toursheroh1: "Adventure Begins Here",
    toursherop:
      "It offers the opportunity to discover the unique beauties of nature,history and culture with ongoing discovery tours, adventurous routes and guided trips.",
    toursfilterh1: "Search by property name",
    toursfiltersortbytext: "Sort by",
    toursfilterlabelrecommended: "Recommended",
    toursfilterlabellowtogigh: "Price: low to high",
    toursfilterlabelhightolow: "Price: high to low",
    toursfilterlabeldiscount: "Pacgace discount",
    toursfiltertotalprice: "Total price",
    toursfilteroffers: "Offers",
    toursfiltercategories: "Categories",
    tourscardbutton: "Take a look",
    closebtn:"Done",


    tourdetailspackage:"Package",
    tourdetailsstartdate : "Start date : ",
    tourdetailsenddate: "End date : ",
    loading:"Loading . . .",
    tourdetailabouttour:"About the tour",
    tourdetaillanguages : "Supported languages",
    tourdetailincludefeatures : "Include features",
    tourdetailexcludefeatures : "Exclude features",
    tourdetailonline:"Book online or call : ",
    tourdetailperperson:"per person",
    tourdetaillowest:"Lowest price guarantee",
    tourdetaildateandtravelers:"Date and Travelers",
    tourdetailsend:"Send a tour inquiry",
    city:"city",

    aboutusheroh3: "About Us",
    aboutusheroh1: `We Recommend <br />
              Beautiful <span>Destination</span> <br />
              every month`,
    aboutusheaderp:
      "Joyful is one of the most popular Travel agencies for those who want to explore the world and go on adventures, we can also provide beautiful destination around the world and take you around.",
    aboutuslearnmorea: "Learn More",
    aboutusformoreinformation: "For more information",
    aboutustextdivh1: "Forget the past, live the adventure now!",
    aboutustextdivp: `Joyful Travel is dedicated to providing seamless and
              budget-friendly travel experiences for those who love to explore
              the world. With our professional team and trusted international
              and local partners, we strive to create unforgettable experiences
              for our customers. <br />
              <br /> Our commitment to care and professionalism is felt by every
              traveler. Exceptional service and customer satisfaction are our
              top priorities. Travel with Joyful Travel and make every moment
              unforgettable!`,
    aboutustextdiva: "Tours",
    aboutuscompanyinfoh1: "Joyful Travel LLC",
    aboutuscompanyinfop1:
      "Joyful Travel was founded in 2010 and specializes in tourism and related services. Our offerings include flight ticket sales, hotel reservations, transfers, visa support, conference organization, accommodation for international guests, guided tours, and more. Our goal is to provide our customers with a seamless and unforgettable travel experience.",
    aboutuscompanyinfop2: `Joyful Travel offers special pricing and flexible payment
                options tailored to our customers' budgets. Payments can be made
                conveniently via cash or bank transfer. <br /> <br />
                Our primary mission is to provide top-quality service and ensure
                customer satisfaction at the highest level. To achieve this,
                Joyful Travel has implemented an innovative digital survey
                platform to better understand customer needs and continuously
                improve its services. By considering customer feedback, we
                regularly <br /> enhance and refine our offerings. <br />Travel with Joyful
                Travel and experience the difference!`,

    contactinfoh3: "Contact info",
    contactinfoh1: "Get in touch",
    contactinfop: `We'love to hear from you. Our friendly <br /> team is always
                here to chat`,
    contactinfocard1h2: "Chat to us",
    contactinfocard1p: "Our friendly team is here to help",
    contactinfocard2h2: "Office",
    contactinfocard2p: "Come say hello at our office HQ.",
    contactinfocard3h2: "Phone",
    contactinfocard3p: "Our friendly team is here to help",
    contactinfoform: "Leave a comments",
    contactinfoformname: "Name",
    contactinfoformemail: "Email",
    contactinfoformphone: "Phone",
    contactinfoformsubject: "Subject",
    contactinfowritehere: "Write here",
    contactinfosubmit: "Submit",
    contactinfomap: "Map",
    contactinfolocation: "Location",

    instagramh1:`See More. Share <br/>
    More.
    Follow Us on<br/> 
    <span>Instagram</span>`,
    instagramp:"Let’s explore the world together—capturing moments, embracing creativity, and sharing unforgettable stories on Instagram!",
    instagrambutton:"Follow us",

    specialoffer:"Special offer",
    discountpackage:"Discount package",
    standartpackage:"Standart package",


    home:"Home",
    contactus:"Contact us",
    footertransitions:"Transitions",
  },
  az: {
    navtours: "Turlar",
    navservices:"Xidmətlər",
    navaboutus: "Haqqımızda",
    navcontact: "Bizimlə əlaqə",
    heroh3: "Səyahət istiqamətini seçin",
    heroh1: `Yeni Maceralar,
              <br />
              Qaçışlar, Həyəcanlar və <br />
              Təcrübələr
              <span> üçün vaxtdır</span>`,
    herop: `Gəlin qlobal bir səyahətə çıxaq, müxtəlif <br /> mədəniyyətlərə
              qərq olaq və dünyanı gəzərkən <br /> unudulmaz xatirələr yaradaq!`,
    companyh2: `Macəranızı başlamaq <span>vaxtıdır.</span>`,
    companyp: `              Səyahət etmək yeni mədəniyyətləri kəşf etmək, fərqli mətbəxləri
              dadmaq və dünyanı daha yaxşı tanımaq üçün unikal bir fürsətdir.
              Lakin doğru səyahət yoldaşını seçmək təcrübəni daha rahat, zövqlü
              və unudulmaz edə bilər. Və burada Joyful Travel devrə girməyə
              başlayır!
              <br />
              <br />
              Joyful Travel ilə səyahət etmək sizə yalnız bir istirahət təklifi
              etmir, həm də unikal bir təcrübə təqdim edir. Bəs niyə bizi
              seçməlisiniz?`,

    companyhomecard1:
      "Sərhədləri Aşaraq: Dünyanın Ən Möhtəşəm Məkanlarına Səyahət",
    companyhomecard2:
      "Daha Çox Təcrübə, Daha Az Xərclə – Rəqibsiz Təkliflər və Eksklüziv Endirimlərlə",
    companyhomecard3:
      "Ölkələr, Sonsuz Macəralar: Dünyanın Gizli İncilərini Kəşf Edin",
    companyhomecard4:
      "Eksklüziv Təkliflər və Unikal Təcrübələrlə Unudulmaz Səyahətlərə Başlayın",

    activetourhr: "Fərqli ölkələrdə maraqlarınıza uyğun aktiv turlar",
    activetourlisth1: "Aktiv turlar",
    activetourlista: "Bütün istiqamətləri görün",
    blogsectionhr: "Fərqli ölkələrdən məlumatlar",
    bloglisth2: "Orada bir çox imkanlar dünyası var  ",
    experienceh1: "Təcrübə",
    homeaboutushr: "Məlumat",
    homeaboutush1: "Haqqımızda",
    homeaboutush2: "NİYƏ BİZ ?",
    homeaboutusheadertext: `<span>Joyful Travel</span> nədir tam olaraq ?`,
    homeaboutusheaderparagraph: `Joyful Travel 2010-cu ildə təsis olunmuş bir səyahət şirkətidir
                və dünyanın hər yerində xoş və rahat səyahətlər təklif edir.
                Müştərilərinə ən yaxşı tətil təcrübəsini təmin etməyi hədəfləyən
                Joyful Travel, viza prosedurlarından qalmaq üçün yerə, uçuş
                biletlərindən şəxsi turlara qədər geniş xidmətlər təklif edir.
                Bizimlə dünyada unudulmaz səyahətlərə çıxın!`,
    homeaboutuslist1h1: "Müxtəliflik",
    homeaboutuslist1p: `Səyahətiniz üçün bütün seçimlər, xüsusi kampaniyalar və
                      məhsulun keyfiyyəti haqqında sizi məlumatlandıracağıq və
                      ehtiyaclarınıza uyğun bir səyahət paketi seçə
                      biləcəksiniz.`,
    homeaboutuslist2h1: "Rahat və ümumi satış",
    homeaboutuslist2p: `Səyahətinizin hər bir aspektini, aviaşirkətlərdən
                      avtomobil kirayəsinə, qalmaq yerlərindən iş görüşlərinə
                      qədər planlaşdıraraq sizə vaxt və pul qazandıracağıq.`,
    homeaboutuslist3h1: "Əminlik",
    homeaboutuslist3p: `2015-ci ildən bəri, şəffaf və keyfiyyətli xidmətimizlə
                      müştərilərimizin etibarını qazandıq. Başqa heç bir
                      şirkətdən fərqli olaraq müştərilərimizə üstün xidmət
                      göstərmək üçün hər addımda yanınızdayıq.`,

    toursheroh1: "Macəra Buradan Başlayır",
    toursherop:
      "Davam edən kəşfiyyat turları, macəralı marşrutlar və bələdçili səfərlər ilə təbiətin, tarixin və mədəniyyətin unikal gözəlliklərini kəşf etmək imkanı təqdim edir.",
    toursfilterh1: "Ölkə və ya şəhər adına görə axtarın",
    toursfiltersortbytext: "Sırala",
    toursfilterlabelrecommended: "Tövsiyə olunur",
    toursfilterlabellowtogigh: "Qiymət: aşağıdan yuxarıya",
    toursfilterlabelhightolow: "Qiymət: yuxarıdan aşağıya",
    toursfilterlabeldiscount: "Pacgace discount",
    toursfiltertotalprice: "Cəm qiymət",
    toursfilteroffers: "Təkliflər",
    toursfiltercategories: "Kateqoriyalar",
    tourscardbutton: "Baxın",
    closebtn:"Bitdi",



    tourdetailspackage:"Paket",
    tourdetailsstartdate : "Başlanğıc tarixi : ",
    tourdetailsenddate: "Bitiş tarixi : ",
    loading:"Yüklənir . . .",
    tourdetailabouttour:"Tur haqqında",
    tourdetaillanguages : "İstifadə olunan dillər",
    tourdetailincludefeatures : "Daxil olan özəlliklər",
    tourdetailexcludefeatures : "Daxil olmayan özəlliklər",
    tourdetailonline:"Online rezerv və ya zəng edin : ",
    tourdetailperperson:"adam başı",
    tourdetaillowest:"Aşağı qiymət qarantisi",
    tourdetaildateandtravelers:"Tarix və paket məlumatı",
    tourdetailsend:"Sorğu göndərin",
    city:"şəhər",

    aboutusheroh3: "Haqqımızda",
    aboutusheroh1: `Hər ay gözəl <br />
              məkanlar <span>tövsiyə</span> <br />
              edirik`,
    aboutusheaderp:
      "Joyful, dünyanı kəşf etmək və macəralara atılmaq istəyənlər üçün ən məşhur turizm agentliklərindən biridir. Biz həmçinin dünyanın müxtəlif gözəl məkanlarını təklif edərək sizi bu yerlərə aparırıq.",
    aboutuslearnmorea: "Ətraflı",
    aboutusformoreinformation: "Daha ətraflı məlumat üçün",
    aboutustextdivh1: "Keçmişi unudun, indi macəranı yaşayın!",
    aboutustextdivp: `Joyful Travel dünyanı kəşf etməyi sevənlər üçün qüsursuz və
              büdcəyə uyğun səyahət təcrübəsi təqdim etməyə həsr olunub. Peşəkar
              komandamız və etibarlı beynəlxalq və yerli tərəfdaşlarımızla
              müştərilərimiz üçün unudulmaz təcrübələr yaratmağa çalışırıq.
              <br />
              <br />
              Bizim qayğıya və peşəkarlığa sadiqliyimizi hər bir səyahətçi hiss
              edir. Müstəsna xidmət və müştəri məmnuniyyəti bizim əsas
              prioritetlərimizdir. Joyful Travel ilə səyahət edin və hər anı
              unudulmaz edin!`,
    aboutustextdiva: "Turlar",
    aboutuscompanyinfoh1: "Joyful Travel MMC",
    aboutuscompanyinfop1:
      "Joyful Travel 2010-cu ildə təsis olunmuşdur və turizm və əlaqəli xidmətlər sahəsində ixtisaslaşmışdır. Təklif etdiyimiz xidmətlərə uçuş bileti satışları, otel bronları, transferlər, viza dəstəyi, konfrans təşkilatçılığı, beynəlxalq qonaqlar üçün yaşayış, bələdçi ilə turlar və daha çox daxildir. Məqsədimiz müştərilərimizə problemsiz və unudulmaz bir səyahət təcrübəsi təqdim etməkdir.",
    aboutuscompanyinfop2: `Joyful Travel, müştərilərimizin büdcələrinə uyğun xüsusi
                qiymətlər və çevik ödəniş seçimləri təklif edir. Ödənişlər
                rahatlıqla nağd və ya bank köçürməsi vasitəsilə edilə bilər.
                <br /> <br />
                Əsas missiyamız yüksək keyfiyyətli xidmət təqdim etmək və
                müştəri məmnuniyyətini ən yüksək səviyyədə təmin etməkdir. Bunun
                üçün Joyful Travel, müştərilərlə daha effektiv ünsiyyət qurmaq
                və onların ehtiyaclarını daha yaxşı anlamaq məqsədilə rəy və
                təkliflərə xüsusi önəm verir. Əgər bizim şirkət rəhbərliyi ilə
                əlaqə saxlamaq istəsəniz, "Bizimlə Əlaqə" səhifəsindən bizə
                mesaj göndərə bilərsiniz. Müştəri rəylərini nəzərə alaraq,
                təkliflərimizi mütəmadi olaraq yaxşılaşdırır və
                təkmilləşdiririk. Joyful Travel ilə səyahət edin və fərqi hiss
                edin!`,

    contactinfoh3: "Əlaqə məlumatları",
    contactinfoh1: "Əlaqə saxlayın",
    contactinfop: `We'love to hear from you. Our friendly <br /> team is always
                here to chat`,
    contactinfocard1h2: "Bizimlə söhbət edin",
    contactinfocard1p: "Our friendly team is here to help",
    contactinfocard2h2: "Ofis",
    contactinfocard2p: "Gəlin, ofisimizə baş çəkin.",
    contactinfocard3h2: "Telefon",
    contactinfocard3p: "Our friendly team is here to help",
    contactinfoform: "Şərh buraxın",
    contactinfoformname: "Ad",
    contactinfoformemail: "E-poçt",
    contactinfoformphone: "Əlaqə nömrəsi",
    contactinfoformsubject: "Mövzu",
    contactinfowritehere: "Buraya yazın",
    contactinfosubmit: "Göndər",
    contactinfomap: "Xəritə",
    contactinfolocation: "Ünvan",

    instagramh1:`Ətraflı baxın. Daha <br />
              çox paylaş. Bizi <br />
              <span>Instagram</span> da izləyin.`,
    instagramp:"Gəlin dünyanı birlikdə kəşf edək anılarını çəkək, yaradıcı fikirləri paylaşaq və Instagram-da unudulmaz hekayələr paylaşaq!",
    instagrambutton:"Bizi izləyin!",

    specialoffer:"Xüsusi təklif",
    discountpackage:"Endirimli tur",
    standartpackage:"Standart paket",

    home:"Ana səhifə",
    contactus:"Bizimlə əlaqə",
    footertransitions:"Keçidlər",

    footercopyright : "2025 Joyful Travel şirkəti. Bütün hüquqlar qorunur. Bu saytın heç bir hissəsi bizim yazılı icazəmiz olmadan kopyalana bilməz."
  },
};

export default translation;
